import {
	default as AkModal,
	type ModalDialogProps as AkModalDialogProps,
} from '@atlaskit/modal-dialog';

import type {
	ChoreographedComponentProps,
	ChoreographerMessageTypes,
	ChoreographerUtilities,
} from '../../types';
import { wrapComponentForChoreographer } from '../utils';

export const Modal: {
	({
		shouldBeChoreographed,
		withChoreographedRender,
		...props
	}: AkModalDialogProps &
		ChoreographerUtilities &
		Partial<ChoreographedComponentProps> & {
			messageType?: ChoreographerMessageTypes;
		}): React.JSX.Element;
	displayName: string;
} = wrapComponentForChoreographer<AkModalDialogProps>(AkModal);
